// extracted by mini-css-extract-plugin
export default {"body":"introduce_body__vNbPX","introduce":"introduce_introduce__wVGGo","profileImg":"introduce_profileImg__sNGuR","text":"introduce_text__cz2x-","mask":"introduce_mask__LdEsI"};